import * as React from 'react';
import styled from 'styled-components';
import { ImageData } from '@packages/common';

const ImageStyled = styled.img`
  width: 100%;
  max-width: 100%;
`;

type ImageType = 'image/jpeg' | 'image/webp' | 'image/avif';

export const SourceMaps: React.FC<{ srcSet?: string[]; type?: ImageType; sizes: string[] }> = ({
  srcSet,
  sizes,
  type = 'image/webp',
}) => {
  if (!srcSet) {
    return null;
  }

  return (
    <source sizes={sizes.join(', ')} key={type} srcSet={srcSet.join(', ')} type={type} data-testid="image-source-map" />
  );
};

export const Image: React.FC<{ imageData: ImageData; className?: string }> = ({ className, imageData }) => {
  const { src, srcSetWebp, alt, width, height, sizes } = imageData;

  return (
    <picture>
      <SourceMaps srcSet={srcSetWebp} type="image/webp" sizes={sizes} />
      <ImageStyled loading="lazy" className={className} src={src} alt={alt} width={width} height={height} />
    </picture>
  );
};
